import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Link,
  List,
  ListItem,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import LinkIcon from "@material-ui/icons/Link";
import campusConfig from "../../../json/campus_config.json";
import useDrawerAccordionBaseStyles from "./styles/useDrawerAccordionBaseStyles";
import useLinkListAccordionStyles from "./styles/useLinkListAccordionStyles";
import {
  useLanguage,
  localizedField,
  t,
} from "../../../contexts/LanguageContext";

function LinkListAccordion() {
  const baseClasses = useDrawerAccordionBaseStyles();
  const linkClasses = useLinkListAccordionStyles();
  const classes = { ...baseClasses, ...linkClasses };
  const { language } = useLanguage();
  const normalizedLinks = (
    Array.isArray(campusConfig.drawerLinks) ? campusConfig.drawerLinks : []
  )
    .map((item) => ({
      ...item,
      label: item?.label ?? "",
      href: item?.href ?? "",
      note: item?.note ?? "",
    }))
    .filter((item) => item.label && item.href);

  if (normalizedLinks.length === 0) return null;

  return (
    <Accordion defaultExpanded className={classes.accordion}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        className={classes.accordionSummary}
      >
        <Typography className={classes.accordionSummaryText}>
          {t("linkList", language)}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetails}>
        <List className={classes.linkList}>
          {normalizedLinks.map((item) => (
            <ListItem key={item.href} className={classes.linkItem}>
              <Link
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.linkAnchor}
              >
                <LinkIcon className={classes.linkIcon} />
                <span className={classes.linkTextWrap}>
                  <span className={classes.linkLabel}>
                    {localizedField(item, "label", language)}
                  </span>
                  {item.note ? (
                    <span className={classes.linkNote}>
                      {localizedField(item, "note", language)}
                    </span>
                  ) : null}
                </span>
              </Link>
            </ListItem>
          ))}
        </List>
      </AccordionDetails>
    </Accordion>
  );
}

export default React.memo(LinkListAccordion);
